import React from "react";
import { SearchIcon } from "@chakra-ui/icons";
import InputCustom from "./InputCustom";

const SearchBar: React.FC = () => {
  return <InputCustom leftIcon={<SearchIcon color="brand.neutral.500" />} />;
};

export default SearchBar;
